<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Notes</span>

        </template>
        <el-form
            ref="ruleFormRef"
            :model="form"
            status-icon
            :rules="rules"
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"

        >

            <el-form-item prop="message">
                <el-input  v-model="form.message" placeholder="Enter Note...." type="textarea" :rows="4" />

            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm" :disabled="loading" :loading="loading">Add Note</el-button>

            </el-form-item>

        </el-form>
        <el-scrollbar height="500px" always>
            <el-timeline>
                <el-timeline-item  placement="top" v-for="log in enquiry.logs" :timestamp="(log.user ? log.user.name : 'Customer' )+' at '+log.created_at">
                    <el-card>
                        <h6>{{log.title}}</h6>
                        <p v-html="log.message"></p>
                    </el-card>
                </el-timeline-item>

            </el-timeline>
        </el-scrollbar>

    </el-card>


</template>

<script>
import {
    ElScrollbar,ElTimelineItem,ElTimeline,ElCard,ElTag,ElRow,ElCol,ElButton,ElDrawer,ElForm,ElFormItem,ElInput,ElSelect,ElOption
} from 'element-plus'
import { Edit } from '@element-plus/icons-vue'

export default {
    name: "EnquiryLogs",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElScrollbar,ElTimelineItem,ElTimeline,ElSelect,ElOption,ElCard,ElTag,ElRow,ElCol,ElButton,Edit,ElDrawer,ElForm,ElFormItem,ElInput },
    data() {
        return {
            loading:false,
            edit:false,
            states:[],
            cities:[],
            form:{
                message:'',
            },
            rules:{
                message: [
                    {
                        required: true, message: 'Enter Note',
                        trigger: ['blur','change'],
                    }
                ],

            }
        }
    },
    created(){

    },
    methods:{


        submitForm(){
            const formEl=this.$refs.ruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.save()
                } else {
                    return false
                }
            })


        },
        save(){
            let currentObj = this;
            this.loading=true;
            axios.post('/addenquirynote?id='+this.enquiry.id,this.form).then(function (response) {


                toastr.success('Note Added Succesfully.');
                currentObj.$emit("saved");
                currentObj.loading=false;
                currentObj.form.message=" ";


            })
                .catch(function (error) {
                    toastr.error('Something Wrong try again.');
                });
        }
    }
}
</script>

<style scoped>

</style>
